// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Notification_wrapper__3uBxg","description":"Notification_description__inciK","imageWrapper":"Notification_imageWrapper__gSqmD","image":"Notification_image__1cR4a"};